import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const EmailText = {
	name: NAME,
	apiProvider,
	router,
};
